import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  const isActive = (path: string) => {
    return location.pathname === path ? 'text-[#0096B4] font-medium' : 'text-gray-700 hover:text-[#0096B4]';
  };
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-79">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-80">
        <Link to="/" className="flex items-center" data-id="element-81">
          <span className="text-black font-bold text-xl" data-id="element-82">KATALINA</span>
          <span className="text-[#0096B4] text-xl ml-1" data-id="element-83">BOCK</span>
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-84">
          <Link to="/" className={`${isActive('/')} transition-colors duration-200`} data-id="element-85">
            Home
          </Link>
          <Link to="/portfolio" className={`${isActive('/portfolio')} transition-colors duration-200`} data-id="element-86">
            Portfolio
          </Link>
          <Link to="/about" className={`${isActive('/about')} transition-colors duration-200`} data-id="element-87">
            About
          </Link>
          <Link to="/contact" className={`${isActive('/contact')} transition-colors duration-200`} data-id="element-88">
            Contact
          </Link>
        </nav>
        {/* Mobile Menu Button */}
        <button onClick={toggleMenu} className="md:hidden focus:outline-none" aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-89">
          {isMenuOpen ? <XIcon size={24} data-id="element-90" /> : <MenuIcon size={24} data-id="element-91" />}
        </button>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white absolute w-full shadow-lg" data-id="element-92">
          <nav className="flex flex-col px-4 py-2" data-id="element-93">
            <Link to="/" onClick={closeMenu} className={`py-3 border-b border-gray-100 ${isActive('/')}`} data-id="element-94">
              Home
            </Link>
            <Link to="/portfolio" onClick={closeMenu} className={`py-3 border-b border-gray-100 ${isActive('/portfolio')}`} data-id="element-95">
              Portfolio
            </Link>
            <Link to="/about" onClick={closeMenu} className={`py-3 border-b border-gray-100 ${isActive('/about')}`} data-id="element-96">
              About
            </Link>
            <Link to="/contact" onClick={closeMenu} className={`py-3 ${isActive('/contact')}`} data-id="element-97">
              Contact
            </Link>
          </nav>
        </div>}
    </header>;
}